import { TreeNode } from 'primeng/api';
import { ValidatorFn } from '@angular/forms';

export function formatDate(date: Date | null | string | undefined): string | null {
  if (date == null || !(date instanceof Date)) {
    return date as string;
  }
  let month = '' + (date.getMonth() + 1);
  let day = '' + date.getDate();
  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }

  return [date.getFullYear(), month, day].join('-');
}

export function today(): Date {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

export function formatTime(date: Date | null): number | null {
  if (!date) {
    return null;
  }
  return date.getHours() + date.getMinutes() / 60;
}

export function minDate(...dates: (Date | null)[]): Date | null {
  return (
    dates
      .filter((d) => d)
      .map((d) => d as Date)
      .sort((a, b) => a.getTime() - b.getTime())[0] ?? null
  );
}

export function maxDate(...dates: (Date | null)[]): Date | null {
  return (
    dates
      .filter((d) => d)
      .map((d) => d as Date)
      .sort((a, b) => b.getTime() - a.getTime())[0] ?? null
  );
}

export function determineTacsParent(tacsId: string | undefined, parentNode?: TreeNode): TreeNode | undefined {
  while (parentNode != null && !tacsId?.startsWith(parentNode?.data.tacsId)) {
    parentNode = parentNode?.parent;
  }
  return parentNode;
}

export function minDateValidator(getMinDate: () => Date | undefined): ValidatorFn {
  return (control) => {
    const min = getMinDate();
    if (min == null || !control.value) {
      return null;
    }
    return control.value >= min ? null : { minDate: false };
  };
}
